import Button from '@mui/joy/Button';
import ButtonGroup from '@mui/joy/ButtonGroup';
import IconButton from '@mui/joy/IconButton';
import Settings from '@mui/icons-material/Settings';

export default function SpacingButtonGroup() {
  return (
    <ButtonGroup spacing="0.5rem" aria-label="spacing button group">
      <Button>One</Button>
      <Button disabled>Two</Button>
      <Button>Three</Button>
      <IconButton>
        <Settings />
      </IconButton>
    </ButtonGroup>
  );
}
